import { SliderViewModel } from "../../@types/generated/SliderViewModel";
import { get } from "../api";

type Response = {
	data: {
		success: boolean;
		result: Array<SliderViewModel>;
		error: any;
	};
};

export function getComplementaryFromCart() {
	return get<Response>(
		"/actions/quantity-shop/product/get-complementary-from-cart"
	);
}

export function getComplementaryFromProduct(product: number) {
	return get<Response>(
		"/actions/quantity-shop/product/get-complementary-from-product?product=" +
			product
	);
}
